import { render, staticRenderFns } from "./SoundRecorder.vue?vue&type=template&id=a59aecc2&scoped=true"
import script from "./SoundRecorder.vue?vue&type=script&lang=js"
export * from "./SoundRecorder.vue?vue&type=script&lang=js"
import style0 from "./SoundRecorder.vue?vue&type=style&index=0&id=a59aecc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a59aecc2",
  null
  
)

export default component.exports